import { Formik, Form } from "formik";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";

interface HeaderFormProps {
  initialValues: any;
  validationSchema: any;
  onSubmit: (
    values: any,
    formikHelpers: {
      resetForm: () => void;
    }
  ) => Promise<void>;
  isLoading?: boolean;
}

const sectionTitleClasses = "mr-auto mt-4 text-primary font-semibold";

const HeaderForm: React.FC<HeaderFormProps> = ({
  initialValues,
  validationSchema,
  onSubmit,
  isLoading,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => {
        return (
          <Form className="mx-auto w-3/5 flex flex-col items-center mt-12 gap-3">
            <TextField
              id="displayName"
              value={values.displayName}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Nom de la Catégorie"
            />

            <TextField
              id="description"
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Description"
            />

            <h3 className={sectionTitleClasses}>Ordre d&apos;affichage</h3>
            <TextField
              id="displayOrder"
              value={values.displayOrder}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Ordre d'affichage"
            />

            <Button
              className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white mt-4"
              disabled={isSubmitting || isLoading}
              type="submit"
            >
              Enregistrer
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default HeaderForm;
